function loadBlogData() {

    var lang = $('html').attr('lang') || 'cz';

    // Každý jazyk má vlastní sessionStorage
    var storageKeyPoradna =
        document.location.hostname +
        "-storredNewsDataPoradna-" +
        lang;

    // Pokud později znovu zapneš blogs:
    var storageKeyBlogs =
        document.location.hostname +
        "-storredNewsDataBlogs-" +
        lang;


    var storredNewsPoradna =
        sessionStorage.getItem(storageKeyPoradna);

    // var storredNewsBlogs =
    //     sessionStorage.getItem(storageKeyBlogs);


    if (storredNewsPoradna) {

        $(".poradit .poradna").html(
            JSON.parse(storredNewsPoradna)
        );

        // $(".item.blogs .wrapper").html(
        //     JSON.parse(storredNewsBlogs)
        // );

    } else {

        $.ajax({

            url: translation('urlporadna'),

            type: "GET",

            success: function (response) {

                var content = $(response);

                var newsItems = content
                    .find(".news-item")
                    .slice(0, 7);

                var poradnaHtml = "";
                var blogsHtml = "";


                newsItems.each(function (index, element) {

                    var $element = $(element);

                    var $elementTitle = $element
                        .find(".title")
                        .text()
                        .trim();

                    var $elementLink = $element
                        .find(".title")
                        .attr("href");


                    if (index < 2) {

                        var $elementDesc = $element
                            .find(".description")
                            .text()
                            .trim();


                        poradnaHtml += `
                            <a href="${$elementLink}" class="question">
                                <div class="h6">
                                    ${$elementTitle}
                                </div>

                                <p>
                                    ${$elementDesc}
                                </p>
                            </a>
                        `;

                    } else {

                        var $elementImgEl = $element
                            .find(".image img");

                        var $elementImg =
                            $elementImgEl.attr("data-src") ||
                            $elementImgEl.attr("src");


                        blogsHtml += `
                            <a href="${$elementLink}" class="item">
                                <span class="imgBox">
                                    <img
                                        src="${$elementImg}"
                                        loading="eager"
                                    />
                                </span>

                                <span>
                                    ${$elementTitle}
                                </span>
                            </a>
                        `;
                    }

                });


                $(".poradit .poradna").html(
                    poradnaHtml
                );


                // $(".item.blogs .wrapper").html(
                //     blogsHtml
                // );


                // Uložení podle jazyka
                sessionStorage.setItem(
                    storageKeyPoradna,
                    JSON.stringify(poradnaHtml)
                );


                // Pokud později znovu zapneš blogs:
                // sessionStorage.setItem(
                //     storageKeyBlogs,
                //     JSON.stringify(blogsHtml)
                // );

            },


            error: function (xhr, status, error) {

                console.error(
                    "Error fetching rating data:",
                    status,
                    error
                );

            }

        }).done(function () { });

    }
}



$(document).ready(function () {

    loadBlogData();

});



if ($("#newsWrapper").length) {

    setBlogPage();


    function setBlogPage() {

        $("#newsWrapper .news-item").each(function () {

            var $text = $(this).find(".text");

            var link = $text
                .find("a.title")
                .attr("href");


            $text.append(
                '<a href="' +
                link +
                '" class="readMore">' +
                translation('precistClanek') +
                '</a>'
            );

        });

    }


    document.addEventListener(
        "ShoptetDOMPageContentLoaded",
        setBlogPage
    );

}



if ($('.type-post').length) {

    var publishedTime = $(
        'meta[property="article:published_time"]'
    ).attr('content');


    if (publishedTime) {

        $(".topWrapper .topText").prepend(
            '<span>' +
            publishedTime +
            '</span>'
        );

    }


    $(".topWrapper .topText").prepend(
        $('h1').clone()
    );

}



if ($('.type-post.in-poradna').length) {

    var ogImage = $(
        'meta[property="og:image"]'
    ).attr('content');


    if (ogImage) {

        var $topImage = $(
            '.topWrapper .topImage'
        );


        if ($topImage.length) {

            $topImage.append(
                '<img src="' +
                ogImage +
                '" alt="">'
            );

        } else {

            $('h1').after(
                '<img src="' +
                ogImage +
                '" alt="">'
            );

        }

    }

}



/*
if ($('.poradit').length) {

    $('.poradit .buttons')
        .prepend(
            $("footer#footer .contact-box li span.tel a")
                .clone()
                .addClass("btn btn-primary")
                .text('Zavolat poradnu')
        );

}
*/



/*
if ($('body.in-poradna.type-posts-listing').length) {

    $('h1').after(
        '<img src="/user/documents/upload/sablona/poradna_hlavni.jpg" alt="">'
    );

}
*/